import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";

export const ForgetPasswordSlicer = createSlice({
  name: "ForgetPassword",
  initialState: {
    data: {},
    isLoading: false,
  } as IReduxState<null>,
  reducers: {
    forgetPassword: (state, _) => {
      state.isLoading = true;
    },
    successForgetPassword: (state, action) => {
      console.log(action.payload);
      
      state.isLoading = false;
      state.data = action.payload;
    },
    failureForgetPassword: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearForgetPassword: (state) => {
      state.data = {};
    },
  },
});

export const {
  forgetPassword,
  successForgetPassword,
  failureForgetPassword,
  clearForgetPassword,
} = ForgetPasswordSlicer.actions;

export default ForgetPasswordSlicer.reducer;
